






import { Component, Vue } from 'vue-property-decorator'
import EasingEditor from './src/EasingEditor.vue'

type Easing = string

@Component({
  components: {
    EasingEditor
  }
})
export default class App extends Vue {
  easing: Easing = 'cubic-bezier(0.2, 0.1, 0.2, 0.8)'
}
